export default __webpack_public_path__ + "static/BanImg3-1eaa876f537acbdccbc4ef1e6ebba7b6.webp";